// A $( document ).ready() block.

$(document).ready(function() {
    /* Accordion for Locator */

    $('.increaseQty').on('click', function() {
        var $parentElm = $(this).parents('.qtySelector');
        var maxVal = $parentElm.find('.qtyValue').attr('max');
        $(this).addClass('clicked');
        setTimeout(function() {
            $('.clicked').removeClass('clicked');
        }, 100);
        var value = $parentElm.find('.qtyValue').val();
        if (value < maxVal) {
            value++;
        }
        $parentElm.find('.qtyValue').val(value);
    });
    // Decrease product quantity on cart page
    $('.decreaseQty').on('click', function() {
        var $parentElm = $(this).parents('.qtySelector');
        $(this).addClass('clicked');
        setTimeout(function() {
            $('.clicked').removeClass('clicked');
        }, 100);
        var value = $parentElm.find('.qtyValue').val();
        if (value > 1) {
            value--;
        }
        $parentElm.find('.qtyValue').val(value);
    });

    $('.nav-link').hover(
        function() {
            $(this).next().addClass('show');
            $(this).addClass('expanded');
        },
        function() {
            $(this).next().removeClass('show');
            $(this).removeClass('expanded');
        }
    );
    $('.dropdown-menu').hover(
        function() {
            $(this).addClass('show');
            $(this).prev().addClass('expanded');
        },
        function() {
            $(this).removeClass('show');
            $(this).prev().removeClass('expanded');
        }
    );
    /* $('.dropdown').hover(
        function() {
            console.log("onHover enter: .dropdown");
            console.log(this);
            $('.homepage-header').addClass('focus');
        },
        function() {
            console.log("onHover exit: .dropdown");
            $('.homepage-header').removeClass('focus');
        }
    ); */

    $('#hamburger-menu').click(function() {
        $('.mobile-side-nav').removeClass('d-none');
        $('.mobile-side-nav').addClass('d-block');
    });

    $('.icon-close').click(function() {
        $('.mobile-side-nav').removeClass('d-block');
        $('.mobile-side-nav').addClass('d-none');
    });

    $('.image-container').click(function() {
        var url = $(this).find('img').attr('src');
        $('.enlarge-img').find('.enlarge-tag').attr('src', url);
        $('.enlarge-img').modal('show');
    });

    $('.enlarge-img-close').click(function() {
        $('.enlarge-img').modal('hide');
    });

    $('.filter-btn').click(function() {
        $('.filter-container').addClass('d-block');
    });

    $('.back-filter').click(function() {
        $('.filter-container').removeClass('d-block');
    });



    /* Creativate mega menu */
    /* Desktop start */
    $('.creativate-main-nav-desktop .menu-item.dropdown').on("click",
        function (e) {
            e.preventDefault();
        }
    );
    
    $('.creativate-main-nav-desktop .menu-item').on("mouseenter", 
        function (e) {
            e.preventDefault();
            let navId = $(this).attr('id');
            // Remove show class from all dropdowns to avoid jittery look and feel
            let allDropdowns = $(".creativate-mega-menu-dropdown");
            $(allDropdowns).removeClass('show');
            let dropdown = $(".creativate-mega-menu-dropdown[aria-labelledby='" + navId + "']").first();
            $(this).addClass("active");
            $(dropdown).addClass("show");
        }).on("mouseleave",
        function(e) {
            e.preventDefault();
            let navId = $(this).attr('id');
            let dropdown = $(".creativate-mega-menu-dropdown[aria-labelledby='" + navId + "']").first();
            $(this).removeClass("active");
            //$(dropDown).removeClass("show");
        }
    );

    $('.creativate-main-nav-desktop .menu-items').on("mouseleave", 
        function (e) {
            e.preventDefault();
            let allDropdowns = $(".creativate-mega-menu-dropdown");
            $(allDropdowns).removeClass('show');
        }
    );

    $('.creativate-mega-menu-dropdown').on("mouseenter", 
        function (e) {
            e.preventDefault();
            let navId = $(this).attr('aria-labelledby');
            let navItem = $("#" + navId).first();
            // Remove show class from all dropdowns to avoid jittery look and feel
            let allDropdowns = $(".creativate-mega-menu-dropdown");
            //$(allDropdowns).removeClass('show');

            $(navItem).addClass("active");
            $(this).addClass("show");
        }).on("mouseleave",
        function(e) {
            e.preventDefault();
            let navId = $(this).attr('aria-labelledby');
            let navItem = $("#" + navId).first();
            $(navItem).removeClass("active");
            $(this).removeClass("show");
            // Remove show class from all dropdowns just in case
            let allDropdowns = $(".creativate-mega-menu-dropdown");
            $(allDropdowns).removeClass('show');
        }
    );

    /* Desktop end */

    /* Mobile start */
    $('.mobile-menu-toggle').on('click',
        function (e) {
            e.preventDefault();
            if ($('.mobile-menu-content-container').hasClass('show')) {
                let topLevelMobileMenuParent = $('.mobile-menu-content-container');
                $(topLevelMobileMenuParent).removeClass('sub-menu-open');
                $('.mobile-mega-menu-section').removeClass('show');
            }

            $(this).toggleClass('open');
            $('body').toggleClass('noscroll');
            $('.mobile-menu-content-container').toggleClass('show');
        }
    )

    $('.mobile-menu-content-container .main-menu-container .menu-item.has-sub-menu').on("click", 
        function (e) {
            e.preventDefault();
            let navId = $(this).attr('id');
            let section = $(".mobile-mega-menu-section[aria-labelledby='" + navId + "']").first();

            if (section.length == 0) {
                return false;
            }

            let topLevelMobileMenuParent = $('.mobile-menu-content-container');
            $(topLevelMobileMenuParent).addClass('sub-menu-open');
            $(section).addClass("show");
        }
    );

    $('.mobile-mega-menu-section .back-button-header').on('click',
        function (e) {
            e.preventDefault();
            let topLevelMobileMenuParent = $('.mobile-menu-content-container');
            $(topLevelMobileMenuParent).removeClass('sub-menu-open');
            $(this).parent().parent().parent().removeClass('show');
        }
    );


    /* Mobile end */
});
